exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nlabel {\n  text-transform: uppercase;\n}\n#main form input[type=\"email\"] {\n  background-color: #ffffff;\n  background-image: none;\n  border: 1px solid #cccccc;\n  border-radius: 4px;\n  box-shadow: 0 1px 1px rgb(0 0 0 / 8%) inset;\n  color: #555555;\n  display: block;\n  font-size: 14px;\n  height: 34px;\n  line-height: 1.42857;\n  padding: 6px 12px;\n  transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;\n  width: 100%;\n}\n.multiselect__input {\n  border: unset !important;\n}\n.multiselect__input:focus {\n  border: 1px solid #cccccc !important;\n}\n", ""]);

// exports
